import Vue from 'vue';

import internationalPhone from '@dwse-forms/commons/lib/util/validator/internationalPhone';
import kboNummer from '@dwse-forms/commons/lib/util/validator/kbo-nummer';
import { validateInternationalPhoneNumber } from '@dwse/util/js/international-phone-validator';

import VlUiVueComponents, {
  VlModalToggle,
  extend
} from '@govflanders/vl-ui-vue-components';

Vue.use(VlUiVueComponents);

Vue.directive('vl-modal-toggle', VlModalToggle);

extend('internationalPhone', internationalPhone);
extend('kbonummer', kboNummer);
extend('telnr', validateInternationalPhoneNumber);
